import { Link } from "gatsby"
import React from "react"

import SponsorLink from "../../components/promotions/sponsorLink"

import {
  TwitterIcon,
  RedditIcon,
} from 'react-share'

const footerNav = {
  explore: [
    { name: "Recent Launches", href: "/communities/" },
    { name: "Communities by Topic", href: "/topics/" },
    { name: "Community Platforms", href: "/platforms/" },
    { name: "Community Features", href: "/features/" },
    { name: "Community Tools", href: "/tools/" },
  ],
  builders: [
    { name: "List your community", href: "/submit/" },
    // { name: "Claim Your Listing", href: "/submit/" },
    { name: "Promote your community", href: "/partners/community/" },
    { name: "Sponsor the site", href: "/partners/sponsor/" },
    { name: "Advertise on a topic page", href: "/partners/paid-ad/" },
    { name: "Suggest a new topic", href: "/suggest/" },
  ],
  about: [
    { name: "About", href: "/about/" },
    { name: "Privacy", href: "/privacy-policy/" },
    { name: "Terms", href: "/terms-and-conditions/" },
    { name: "Data License", href: "/data-license/" },
  ],
}

const Footer = ({}) => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-16" aria-label="Site footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Main grid */}
        <div className="py-12 sm:py-16 grid grid-cols-2 gap-8 lg:grid-cols-4">

          {/* Brand column */}
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="inline-flex items-center gap-2">
              <span className="text-xl font-extrabold text-gray-900 tracking-tight">
                Hive <span className="text-yellow-500">Index</span>
              </span>
            </Link>
            <p className="mt-3 text-sm text-gray-600 leading-relaxed max-w-xs">
              The internet&apos;s most comprehensive directory of online communities.
              Free to use, free to list.
            </p>

            <div className="mt-6 flex items-center gap-3">
              <a
                href="https://twitter.com/intent/follow?screen_name=thehiveindex"
                aria-label="Follow Hive Index on Twitter"
                target="_blank"
                rel="noopener noreferrer"
                className="opacity-60 hover:opacity-100 transition-opacity"
              >
                <TwitterIcon size={28} round={true} />
              </a>
              <a
                href="https://www.reddit.com/r/hiveindex/"
                aria-label="Hive Index on Reddit"
                target="_blank"
                rel="noopener noreferrer"
                className="opacity-60 hover:opacity-100 transition-opacity"
              >
                <RedditIcon size={28} round={true} />
              </a>
            </div>

            <p className="mt-6 text-xs text-gray-400">
              Built by{" "}
              <a
                href="https://twitter.com/intent/follow?screen_name=foliofed"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-gray-800 transition-colors"
              >
                @foliofed
              </a>
            </p>
          </div>

          {/* Explore column */}
          <div>
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-widest">
              Explore
            </h3>
            <ul className="mt-4 space-y-2.5" role="list">
              {footerNav.explore.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Community builders column */}
          <div>
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-widest">
              Community Builders
            </h3>
            <ul className="mt-4 space-y-2.5" role="list">
              {footerNav.builders.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About column */}
          <div>
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-widest">
              Hive Index
            </h3>
            <ul className="mt-4 space-y-2.5" role="list">
              {footerNav.about.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-8">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-widest">
                Stay Updated
              </h3>
              <p className="mt-3 text-sm text-gray-600">
                New communities and community industry insights, delivered straight to your inbox.
              </p>
              <Link
                to="/newsletter/"
                className="mt-3 inline-block text-sm font-semibold text-yellow-600 hover:text-yellow-700 transition-colors"
              >
                Subscribe to the newsletter →
              </Link>
            </div>
          </div>

        </div>

        {/* Bottom strip */}
        <div className="border-t border-gray-200 py-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} Hive Index. Free to use, free to list.
          </p>

          <SponsorLink location="footer" canHide={false}>
            {({ name, url, descriptor, onClick }) => (
              <p className="text-xs text-gray-600">
                Sponsored by{" "}
                <a
                  href={url}
                  onClick={onClick}
                  target="_blank"
                  rel="noopener noreferrer sponsored"
                  className="text-gray-600 hover:text-gray-900 transition-colors underline underline-offset-2"
                >
                  {name}
                </a>
              </p>
            )}
          </SponsorLink>
        </div>

      </div>
    </footer>
  )
}

export default Footer
